import { useRef } from "react";
import Image from "next/image";
import PrimaryBtn from "@/components/button/primaryBtn";
import { ModalWrapper } from "../ModalWrapper";

function ContactSubmitSuccessModal({ modalId }) {
  const contractModalCloseBtnRef = useRef();

  const handleCloseModal = () => {
    contractModalCloseBtnRef?.current?.click();
  };

  return (
    <ModalWrapper
      ref={contractModalCloseBtnRef}
      modalId={modalId}
      onClose={handleCloseModal}
      isFullHeight={true}
    >
      <section className="flex flex-col items-center py-[1.7rem]">
        <div className="flex justify-center">
          <Image
            src="/assets/icons/check-success.png"
            alt="success-modal"
            width={69}
            height={69}
          />
        </div>
        <h1 className="text-display2 text-darkPrimary text-center font-medium mt-[1.8rem] max-w-[23.625rem]">
          Thank You for your message!
        </h1>

        <p className="text-grayD3 text-heading6 text-center mt-[1.5rem]">
          We will get back to you real soon. Thanks for contacting us!
        </p>

        <div className="flex justify-center mt-[2.7rem] md:mt-[3.375rem]">
          <div className="">
            <PrimaryBtn
              btnText="Continue Shopping"
              className="w-[18.75rem] h-[56px]"
              onClick={handleCloseModal}
            />
          </div>
        </div>
      </section>
    </ModalWrapper>
  );
}

export default ContactSubmitSuccessModal;
